import { combineReducers } from 'redux'

import alarmsReducer from './alarmsReducers'
import appliancesReducer from './appliancesReducer'
import inputsReducer from './inputsReducer'
import inputListsReducer from './inputListsReducer'
import graphReducer from './graphReducer'
import groupListsReducer from './groupListsReducer'
import notificationsReducer from './notificationsReducer'
import groupsReducer from './groupsReducer'
import outputsReducer from './outputsReducer'
import outputListsReducer from './outputListsReducer'
import portsReducer from './portsReducer'
import serviceOverviewReducer from './serviceOverviewReducers'
import settingsReducer from './settingsReducer'
import uiReducer from './uiReducer'
import urlParamReducer from './urlParamReducer'
import userReducer from './userReducer'
import buildInfoReducer from './buildInfoReducer'
import thumbnailReducer from './thumbnailReducer'
import addressMappingReducer from './addressMappingReducer'
import k8sReducer from './k8sReducer'
import networksReducer from './networksReducer'
import overlaysReducer from './overlaysReducer'
import transformationProfileReducer from './transformationProfileReducer'
import adServerReducer from './adServerReducer'
import adAuditReducer from './adAuditReducer'
import adCreativeReducer from './adCreativeReducer'
import adPodReducer from './adPodReducer'
import adBreakReducer from './adBreakReducer'
import adScheduledEventReducer from './adScheduledEventReducer'
import tagsReducer from './tagsReducer'

const reducerMap = {
  addressMappingReducer,
  alarmsReducer,
  appliancesReducer,
  buildInfoReducer,
  graphReducer,
  groupListsReducer,
  groupsReducer,
  inputsReducer,
  inputListsReducer,
  k8sReducer,
  networksReducer,
  notificationsReducer,
  outputsReducer,
  outputListsReducer,
  portsReducer,
  serviceOverviewReducer,
  overlaysReducer,
  transformationProfileReducer,
  adServerReducer,
  adAuditReducer,
  settingsReducer,
  thumbnailReducer,
  uiReducer,
  urlParamReducer,
  userReducer,
  adCreativeReducer,
  adPodReducer,
  adBreakReducer,
  adScheduledEventReducer,
  tagsReducer,
}

export default combineReducers(reducerMap)
